export const parseMatchTime = (match) => {
  if (!match || !match.start_time) return new Date();
  
  // If it's a manual match (no sm_match_id) and ends with 'Z', 
  // it was likely entered as local time but saved as UTC.
  // Stripping 'Z' forces it to be parsed as the local time the admin intended.
  if (!match.sm_match_id && typeof match.start_time === 'string' && match.start_time.endsWith('Z')) {
    return new Date(match.start_time.replace('Z', ''));
  }
  
  return new Date(match.start_time);
};
